"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricePeriodBase = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../../decorators");
class PricePeriodBase extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Start date for this period', example: '2020-01-01' }),
    tslib_1.__metadata("design:type", String)
], PricePeriodBase.prototype, "fromDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'End date for this period', example: '2020-01-01' }),
    tslib_1.__metadata("design:type", String)
], PricePeriodBase.prototype, "toDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({
        description: 'Description',
        example: 'Groene Stroom - Zeker & Vrij - Flexibele looptijd',
    }),
    tslib_1.__metadata("design:type", String)
], PricePeriodBase.prototype, "propositionDescription", void 0);
exports.PricePeriodBase = PricePeriodBase;
